<template>
    <div class="livingVideoList tc-black">
        <div class="title">
            <span class="icon_anthor flex-start fs-20 blod">{{param.hostname ? param.hostname : '鲸视频'}}</span>
        </div>
        <div class="list-box flex-start flex-wrap">
            <div class="out-box" v-for="(obj,i) in datalist" :key="i" @mouseenter="mouseenter">
                <div class="box">
                    <div class="box-nol">
                        <div class="img-box"><img class="img" v-lazy="obj.coverurl" alt=""></div>
                        <div class="subject text-ellipse">{{obj.subject}}</div>
                        <div class="desc fs-12 tc-grey text-ellipse">{{obj.description}}</div>
                    </div>
                    <div class="box-hover" @click="handleClick(obj)" @mouseleave="mouseleave">
                        <div class="img-box"><img class="img" v-lazy="obj.coverurl" alt=""></div>
                        <div class="subject text-ellipses">{{obj.subject}}</div>
                        <div class="desc fs-12 tc-grey text-ellipses">{{obj.description}}</div>
                        <div class="hostname_actions flex-between">
                          <div class="hostname tc-grey fs-12">{{obj.hostname}}</div>
                          <div class="play-btn tc-write fs-12 tc pointer"><span class="el-icon-video-play"></span> 立即播放</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="loadmore fs-14 tc pointer" v-show="page.page<page.pagetotal" @click="loadmore">点击加载更多</div>-->
        <div class="living-loading tc-blue fs-14 tc" v-show="page.page<page.pagetotal">…加载中</div>
    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {getAllVideo} from 'api/web-app'
  import $ from 'jquery'
  export default {
    name: 'livingVideoList',
    data() {
      return {
        datalist: [],
        page: {
          page: 1,
          pagesize: 16,
          pagetotal: 0
        },
        param: {
          hostinnerid: this.$route.query.topicid ? this.$route.query.topicid: '',
          hostname: this.$route.query.hostname ? this.$route.query.hostname: ''
        },
        hover: false,
        liveLoading: false
      }
    },
    mounted() {
      if (this.param.hostname) {
        document.title = this.param.hostname + '-鲸融网-精品直播'
      } else {
        document.title = '鲸视频-鲸融网-精品直播'
      }
      this._getList()
      let _this = this
      $(window).scroll(function () {
        if (_this.liveLoading || _this.page.page >= _this.page.pagetotal) return false
        if (($(document).height() - $(window).height()) -$(window).scrollTop() < 400 && _this.page.page <= _this.page.pagetotal) {
          _this.loadmore()
        }
      });
    },
    beforeDestroy() {
      $(window).unbind('scroll')
    },
    methods: {
      loadmore() {
        if (this.liveLoading) return false
        this.page.page++
        this.liveLoading = true
        this._getList()
      },
      mouseenter(e) {
        if (this.hover) return false
        this.hover = true
        e.target.classList.add('enter')
      },
      mouseleave(e) {
        this.hover = false
        e.target.parentNode.classList.remove('enter')
      },
      handleClick(obj) {
        this.setRefresh(true)
        this.$router.push({name: 'livingVideoView', query: {kmcinnerid: obj.kmcinnerid}})
      },
      _getList(){
        this.setLoading(true)
        getAllVideo({
          data: Object.assign({}, this.page, this.param),
          success: data => {
            this.setLoading(false)
            this.datalist = this.datalist.concat(data.data.content)
            this.page.pagetotal = data.data.pageinfo.pageCount
            this.liveLoading = false
          },
          error: data => {
            this.liveLoading = false
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters([])
    },
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.livingVideoList {
    width: 1200px;
    margin: auto;
    padding: 20px 0 80px 0;
    .title{
        padding-bottom: 20px;
        .icon_anthor:before{
            width: 16px;
            height: 16px;
            margin-right: 10px;
        }
    }
    .list-box{
        .out-box{
            position: relative;
            height: 220px;
            margin-bottom: 20px;
            width: 300px;
        }
        .box{
            padding: 10px;
            width: 280px;
            height: 325px;
            position: absolute;
            .img-box{
                width: 100%;
                border-radius: 4px;
                overflow: hidden;
                .img{
                    width: 100%;
                    height: 100%;
                }
            }
            .subject{
                font-size: 15px;
                line-height: 24px;
                margin: 15px 0 5px 0;
            }
            .desc{
                line-height: 17px;
            }
            .box-nol{
                .img-box{
                    height: 157px;
                }
            }
            .box-hover{
                background: #fff;
                transition: height .5s;
                opacity: 0;
                position: absolute;
                top: 0;
                left: 0;
                width: 300px;
                height: 220px;
                z-index: 1;
                box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
                border-radius: 4px;
                overflow: hidden;
                .img-box{
                    border-radius: 4px 4px 0 0;
                    height: 168px;
                    .img{
                        transition: all .5s;
                    }
                }
                .subject{
                    margin: 15px 10px 5px 10px;
                }
                .desc{
                    line-height: 17px;
                    margin: 0 10px;
                }
                .hostname_actions {
                  padding: 15px 10px 5px;
                }
                .play-btn{
                    // margin-top: 15px;
                    width: 110px;
                    height: 30px;
                    line-height: 30px;
                    background: linear-gradient(270deg, #FF3E3E 0%, #FFAE6E 100%);
                    border-radius: 15px;
                    // margin-left: 10px;
                    &:hover{
                        background: linear-gradient(90deg, #FF3E3E 0%, #FFAE6E 100%);
                    }
                }
            }
            &:hover{
                z-index: 9;
                .hover-mask{
                    display: block;
                }
                .box-hover{
                    opacity: 1;
                    z-index: 10;
                    height: 325px;
                    .img{
                        transform: scale(1.2);
                    }
                }
            }
        }
    }
    .loadmore{
        width: 200px;
        height: 40px;
        line-height: 40px;
        color: #027AFF;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #027AFF;
        margin: 10px auto 20px auto;
    }
    .living-loading{
        width: 200px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #027AFF;
        margin: 0 auto 40px auto;
        line-height: 40px;
    }
}
</style>